(function(){
  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -60px 0px'});
    document.querySelectorAll('.ed-reveal').forEach(function(el){io.observe(el)});
  } else {
    document.querySelectorAll('.ed-reveal').forEach(function(el){el.classList.add('is-in')});
  }
})();